import type {ReactNode} from 'react';
import React from 'react';
import {Box, Typography} from '@mui/material';

export function Section({title, children}: { title: string; children: ReactNode }) {
    return (
        <Box sx={{display: 'flex', flexDirection: 'column', gap: 0.5}}>
            <Typography
                sx={{
                    fontSize: 11, fontWeight: 600, color: '#343A40',
                    textTransform: 'uppercase', letterSpacing: '.06em', mb: 0.25,
                }}
            >
                {title}
            </Typography>
            {children}
        </Box>
    );
}